module.exports = __webpack_public_path__ + "static/taste-of-boba-tea-success-5d1f62a80277cd5b7a17247966acd7e8.jpg";